import {Component, Input, OnInit} from '@angular/core';
import Swal, {default as swal} from 'sweetalert2';
import {FormControl, FormGroup} from '@angular/forms';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import {Router} from '@angular/router';
import {SuspendService} from '../../../shared/service/suspend.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {ReversedSuspendService} from '../../../shared/service/reversed-suspend.service';
import {BlacklistService} from '../../../shared/service/blacklist.service';
import {UserRoleEnum} from '../../../shared/enums/user-role.enum';
import {ReversedSuspendBlacklistService} from '../../../shared/service/reversed-suspend-blacklist.service';
import {ChecklistEnum} from '../../../shared/enums/checklist.enum';
import {ChecklistService} from '../../../service/checklist.service';
import {ChecklistModel} from '../../../shared/dto/checklist.model';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {WorkflowEnum} from '../../../shared/enums/workflow.enum';

@Component({
  selector: 'app-suspend-remarks',
  templateUrl: './suspend-remarks.component.html',
  styleUrls: ['./suspend-remarks.component.scss']
})
export class SuspendRemarksComponent implements OnInit {
  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;
  public isValidChecklist = true;
  public selectedIdArr: number[]=[];
  public checklistId: number[]=[];
  public checklist: ChecklistModel[];
  public checklistType: string;
  public applicantType: string;

  constructor(private router: Router, private suspendService: SuspendService,
              private activeModal: NgbActiveModal,
              private blacklistService: BlacklistService,
              private suspendReverseService: ReversedSuspendService,
              private reverseSuspendBlacklistService: ReversedSuspendBlacklistService,
              private checklistService: ChecklistService,
              private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.approvalModel = this.fromParent.model;
    this.applicantType = this.fromParent.appType;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });
    this.getChecklist();
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;
    this.approvalModel.selectedIdArr = this.selectedIdArr;

    if(this.approvalModel.process === ActionMode.SUSPEND) {
      // alert("Came Here");
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.suspendService.approveRequeat(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({ status: 'Saved', data: "" });
//this.approvalModel
              if(this.router.url.includes('/dashboard/suspend-return-data/')) {
                this.router.navigate(['/dashboard/suspend-return-data',this.approvalModel]);
              }
              if(this.router.url.includes('/reversed-suspend-return-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend-return-datas',this.applicantType]);
              }


              this.suspendService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });
    }else if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND && this.approvalModel.userRole === UserRoleEnum.SHO) {
      // alert("Came Here1");
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {

          this.suspendReverseService.approveRequeat(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/suspend-return-data/')) {
                this.router.navigate(['/dashboard/suspend-return-data',this.approvalModel]);

              }else if(this.router.url.includes('/dashboard/reversed-suspend-return-datas/')) {
                this.router.navigate(['/dashboard/reversed-suspend-return-datas',this.approvalModel]);
              }
              else if(this.router.url.includes('/dashboard/reversed-suspend-return-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend-return-datas',this.applicantType]);
              }
              this.suspendService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });
    }else if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND && this.approvalModel.userRole === UserRoleEnum.EXM) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.blacklistService.approvalProcess(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/suspend-return-data/')) {
                this.router.navigate(['/dashboard/suspend-return-data',this.applicantType]);

              }else if(this.router.url.includes('/dashboard/reversed-suspend-return-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend-return-datas',this.applicantType]);
              }
              this.suspendService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });
    }else if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND_BLACKLIST && this.approvalModel.userRole === UserRoleEnum.EXM) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.blacklistService.approvalProcess(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/reversed-suspend-blacklist-return-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend-blacklist-return-data',this.applicantType]);
              }
              this.suspendService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });
    }else if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND_BLACKLIST && this.approvalModel.userRole === UserRoleEnum.SHO) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.reverseSuspendBlacklistService.approveRequeat(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/suspend-return-data/')) {
                this.router.navigate(['/dashboard/suspend-return-data',this.applicantType]);

              }else if(this.router.url.includes('/dashboard/reversed-suspend-return-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend-return-datas',this.applicantType]);
              }
              else if(this.router.url.includes('/dashboard/reversed-suspend-blacklist-return-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend-blacklist-return-data',this.applicantType]);
              }
              this.suspendService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });
    }
  }

  isAllSelected(id,event) {
    if(event.checked)
      this.selectedIdArr.push(id);
    else {
      var index = this.selectedIdArr.indexOf(id);
      if(index > -1)
        this.selectedIdArr.splice(index,1);
    }

    if(JSON.stringify(this.checklistId)==JSON.stringify(this.selectedIdArr)) {
      this.isValidChecklist = false;
    }else {
      this.isValidChecklist = true;
    }


  }

  getChecklist() {
    if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) {
      this.checklistType = ChecklistEnum.SUS_RET_CHECK_EXM;
    }

    if(this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) {
      this.checklistType = ChecklistEnum.SUS_RET_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED)) {
      this.checklistType = ChecklistEnum.SUS_REV_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED)) {
      this.checklistType = ChecklistEnum.SUS_REV_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED)) {
      this.checklistType = ChecklistEnum.SUS_REV_CHECK_SHO;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_REV_RET_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_REV_RET_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_REV_RET_CHECK_SHO;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_BLACKLIST_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_BLK_REV_RET_CHECK_SHO;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_BLACKLIST_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_BLK_REV_RET_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_BLACKLIST_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_BLK_REV_RET_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_RET_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_RET_CHECK_DG;
    }

    this.checklistService.getChecklistByType(this.checklistType).subscribe(
      (result: any ) => {
        this.checklist = result;
        if(this.checklist.length > 0) {
          this.checklist.forEach(item => {
            this.checklistId.push(item.id);
          });
          this.isValidChecklist = true;
        }else{
          this.isValidChecklist = false;
        }
      }
    );
  }

}
